<template>
    <div class="editor-personage-icon">
        <div class="personage-badges-container" :style="{ marginTop: `-${size}px` }">
            <template v-if="personages.length <= 2">
                <span
                    v-for="(personage, index) in personages"
                    :key="index"
                    class="personage-badge"
                    :style="{ minWidth: `${size}px`, height: `${size}px` }"
                    :title="personage.name"
                >
                    {{ personage.name[0].toUpperCase() }}
                </span>
            </template>
            <template v-else>
                <span
                    class="personage-badge"
                    :style="{ minWidth: `${size}px`, height: `${size}px` }"
                    :title="personages[0].name"
                >
                    {{ personages[0].name[0].toUpperCase() }}
                </span>
                <span
                    class="personage-badge personage-badge--more"
                    :style="{ minWidth: `${size}px`, height: `${size}px` }"
                    :title="hiddenPersonagesTooltip"
                >
                    +{{ personages.length - 1 }}
                </span>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EditorPersonageIcon',
    props: {
        personages: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            size: 20
        };
    },
    computed: {
        hiddenPersonagesTooltip() {
            if (this.personages.length <= 1) return '';
            return this.personages
                .slice(1)
                .map(p => p.name)
                .join(', ');
        }
    },
    methods: {}
};
</script>

<style src="./EditorPersonageIcon.scss" lang="scss"></style>
